import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import KeyboardArrowDownIcon from '../../../../Icon/Svg/KeyboardArrowDownIcon';
const ProfessionalUnitHeaderCategory = (props) => {
    const { item, onClick } = props;
    if (!item.count) {
        return null;
    }
    return (_jsx("li", Object.assign({ className: 'header_category' }, { children: _jsxs("button", Object.assign({ className: 'category_button', onClick: onClick, type: 'button', value: item.value }, { children: [_jsxs("span", Object.assign({ className: 'category_title' }, { children: [_jsx("span", Object.assign({ className: 'title_value' }, { children: item.text })), _jsx(KeyboardArrowDownIcon, { className: 'title_icon white' })] })), _jsxs("span", Object.assign({ className: 'category_count' }, { children: [_jsx("span", Object.assign({ className: 'count_number' }, { children: item.count })), _jsx("span", Object.assign({ className: 'count_unit' }, { children: item.unit }))] }))] })) })));
};
ProfessionalUnitHeaderCategory.propTypes = {
    item: propShape().isRequired,
    onClick: propFunc().isRequired,
};
export default ProfessionalUnitHeaderCategory;
